






















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Products } from "@/api/product";

@Component({})
export default class OrderDetailList extends Vue {
  @Prop({ default: [] }) products!: Products;
  headers = [
    {
      text: "Артикул",
      align: "left",
      value: "Артикул",
      sortable: false
    },
    { text: "Наименование", sortable: false },
    {
      text: "Количество",
      align: "center",
      value: "Количество",
      sortable: false
    },
    { text: "Цена", align: "center", value: "Учетная", sortable: false },
    { text: "Всего", value: "Всего", sortable: false }
  ];
}
